export const skipButtonLabel = `
<svg
  xmlns="http://www.w3.org/2000/svg"
  aria-hidden="true"
  viewBox="0 0 24 24"
  fill="currentColor"
  width="1em"
  height="1em"
  aria-label="Close Tour Icon"
>
  <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z" />
</svg>
`;

export const nextButtonLabel = `
<span>Next</span>
<svg xmlns="http://www.w3.org/2000/svg"
aria-hidden="true"
viewBox="0 3 20 20"
fill="currentColor"
width="1em"
height="1em"
aria-label="Arrow Right Icon">
  <path d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8Z" />
</svg>
`;

export const tooltipTitle = `
Your <span class="tour-right-text">Right</span><span class="tour-payment-text">Payment</span>
`;
